import React from "react";

import FirstTimeBookingConfirmation from "./screens/FirstTimeBookingConfirmation";
import SecondTimeBookingConfirmation from "./screens/SecondTimeBookingConfirmation";

import { LogOnMount } from "@amplitude/react-amplitude";

const BookingConfirmation = ({ servicesCount = 0, ...rest }) => {
  return (
    <div>
      <LogOnMount eventType="booking-confirmation-screen" />

      {servicesCount === 0 ? (
        <FirstTimeBookingConfirmation {...rest} />
      ) : (
        <SecondTimeBookingConfirmation {...rest} />
      )}
    </div>
  );
};

export default BookingConfirmation;



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/BookingConfirmation.js